import React, { useEffect } from 'react';

function Sucursales() {
  useEffect(() => { document.title = 'Sucursales'; }, []);
  return (
    <section className="first-section-padding section-bottom-border">
      <div className="container-fluid my-5">
        <div className="row sucursal-card-gradient rounded-4 p-lg-5 p-4">
          
            
              {/* Columna izquierda: texto */}
              <div className="col-md-5 ps-md-4">
                <div className="h-100 d-flex flex-column justify-content-center">
                  <div>
                    <h1 className="title-sucursal text-start mb-2">
                      Sucursal <br></br><span className="title-span">Plaza Express <br />Las Palmas</span>
                    </h1>
                    <div className="sucursal-direccion mb-2 text-start">
                      <p>
                        <strong>Urano 585 Boca del Río, Veracruz</strong>
                      </p>
                    </div>
                    <div className="sucursal-contacto mb-2 text-start">
                      <a href="tel:2299224146"><p className='m-0'><strong>T.</strong> 229 · 922 · 4146</p></a>
                      <a href="tel:2299840258"><p><strong>C.</strong> 229 · 984 · 0258</p></a>
                      
                    </div>
                    <div className="sucursal-horario text-start">
                      <p className='m-0'><strong>Horario disponible</strong></p>
                      <p className='m-0'>Lunes a Sábado</p>
                      <p className='m-0'>De 10:00 am a 2:00 pm<br/>
                        y 4:00 pm a 8:00 pm</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Columna derecha: mapa */}
              <div className="col-md-7 container-iframe">
                
                  <iframe
                    className="sucursal-iframe"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1884.623096061996!2d-96.11180160216247!3d19.140697777026443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c340fde52606b9%3A0x442af55e6e5bd30d!2zw5NwdGljYXMgUGFyw61z!5e0!3m2!1ses!2smx!4v1753288363890!5m2!1ses!2smx"
                    width="600"
                    height="400"
                    style={{ border: 0, borderRadius: '20px', marginBottom:'-15%' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Sucursal Óptica París"
                  ></iframe>
                
              </div>
            
          
        </div>
        <div className="row sucursal-card-gradient rounded-4 p-lg-5 p-4 mt-5">
          
            
              {/* Columna izquierda: texto */}
              <div className="col-md-5 ps-md-4">
                <div className="h-100 d-flex flex-column justify-content-center">
                  <div>
                    <h1 className="title-sucursal text-start mb-2">
                      Sucursal <br></br><span className="title-span">Martí </span>
                    </h1>
                    <div className="sucursal-direccion mb-2 text-start">
                      <p>
                        <strong>José Martí 512, Fracc. Reforma,<br></br> Veracruz, Ver.</strong>
                      </p>
                    </div>
                    <div className="sucursal-contacto mb-2 text-start">
                      <a href="tel:2299379806"><p className='m-0'><strong>T.</strong> 229 · 937 · 9806</p></a>
                      <a href="tel:2299782418"><p><strong>C.</strong>  229 · 978 · 2418</p></a>
                      
                    </div>
                    <div className="sucursal-horario text-start">
                      <p className='m-0'><strong>Horario disponible</strong></p>
                      <p className='m-0'>Lunes a Sábado</p>
                      <p className='m-0'>De 10:00 am a 2:00 pm<br/>
                        y 4:00 pm a 8:00 pm</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Columna derecha: mapa */}
              <div className="col-md-7 container-iframe">
                
                  <iframe
                    className="sucursal-iframe"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1884.288600647007!2d-96.12564268255615!3d19.16997590000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c341b605a38a6f%3A0x19af20cb3a2721b1!2zw5NwdGljYXMgUGFyw61z!5e0!3m2!1ses!2smx!4v1753292742394!5m2!1ses!2smx"
                    width="800"
                    height="600"
                    style={{ border: 0, borderRadius: '20px', marginBottom:'-15%' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Sucursal Óptica París"
                  ></iframe>
                
              </div>
            
          
        </div>
        <div className="row sucursal-card-gradient rounded-4 p-lg-5 p-4 mt-5">
          
            
              {/* Columna izquierda: texto */}
              <div className="col-md-5 ps-md-4">
                <div className="h-100 d-flex flex-column justify-content-center">
                  <div>
                    <h1 className="title-sucursal text-start mb-2">
                      Sucursal <br></br><span className="title-span">Plaza <br />Las Américas</span>
                    </h1>
                    <div className="sucursal-direccion mb-2 text-start">
                      <p>
                        <strong>Centro Hotelero Local D3, Boca Del Río,<br></br> Veracruz.</strong>
                      </p>
                    </div>
                    <div className="sucursal-contacto mb-2 text-start">
                      <a href="tel:2299273205"><p className='m-0'><strong>T.</strong> 229 · 927 · 3205</p></a>
                      <a href="tel:2292454243"><p><strong>C.</strong> 229 · 245 · 4243</p></a>
                      
                    </div>
                    <div className="sucursal-horario text-start">
                      <p className='m-0'><strong>Horario disponible</strong></p>
                      <p className='m-0'>Todos los días</p>
                      <p className='m-0'>De 11:00 am a 9:00 pm</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Columna derecha: mapa */}
              <div className="col-md-7 container-iframe">
                
                  <iframe
                    className="sucursal-iframe"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1884.6428212582236!2d-96.10820358255614!3d19.138969900000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c340fb73739e7b%3A0x9fe5b6bbc5849218!2zw5NwdGljYXMgUGFyw61z!5e0!3m2!1ses!2smx!4v1753293409819!5m2!1ses!2smx"
                    width="600"
                    height="400"
                    style={{ border: 0, borderRadius: '20px', marginBottom:'-15%' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Sucursal Óptica París"
                  ></iframe>
                
              </div>
            
          
        </div>
        <div className="row sucursal-card-gradient rounded-4 p-lg-5 p-4 mt-5">
          
            
              {/* Columna izquierda: texto */}
              <div className="col-md-5 ps-md-4">
                <div className="h-100 d-flex flex-column justify-content-center">
                  <div>
                    <h1 className="title-sucursal text-start mb-2">
                      Sucursal <br></br><span className="title-span">Centro</span>
                    </h1>
                    <div className="sucursal-direccion mb-2 text-start">
                      <p>
                        <strong>Diaz Mirón 274, casi esq. Abasolo,<br></br> Veracruz, Ver.</strong>
                      </p>
                    </div>
                    <div className="sucursal-contacto mb-2 text-start">
                      <a href="tel:2299317929"><p className='m-0'><strong>T.</strong> 229 · 931 · 7929</p></a>
                      <a href="tel:2292431945"><p><strong>C.</strong> 229 · 243 · 1945</p></a>
                      
                    </div>
                    <div className="sucursal-horario text-start">
                      <p className='m-0'><strong>Horario disponible</strong></p>
                      <p className='m-0'>Lunes a Sábado</p>
                      <p className='m-0'>De 9:30 am a 1:30 pm<br></br> 
                      y 4:00 pm a 8:00 pm</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Columna derecha: mapa */}
              <div className="col-md-7 container-iframe">
                
                  <iframe
                    className="sucursal-iframe"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15072.608487108299!2d-96.1365914!3d19.188557!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c341149ea964ef%3A0x8cfa8fb577243c81!2zw5NwdGljYXMgUGFyw61z!5e0!3m2!1ses-419!2smx!4v1753371576674!5m2!1ses-419!2smx"
                    height="400"
                    style={{ border: 0, borderRadius: '20px', marginBottom:'-15%' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Sucursal Óptica París"
                  ></iframe>
              </div>
            
          
        </div>
      </div>
    </section>
  );
}

export default Sucursales; 